import { Form, Row, Col, Modal } from 'react-bootstrap';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatSubmitNopol } from 'utils/utils';
import { prosesPenghapusan } from 'api/ApiPenghapusan';
import iconNegative from '../assets/icon_negative.svg';

export default function IdentityForm() {
  const [tnkbDaerah, setTnkbDaerah] = useState('');
  const [tnkbSubDaerah, setTnkbSubDaerah] = useState('');
  const [tnkbNomor, setTnkbNomor] = useState('');
  const [noRangka, setNoRangka] = useState('');
  const [noKTP, setNoKTP] = useState('');
  const [noHP, setNoHP] = useState('');
  const [email, setEmail] = useState('');
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  const handleClose = () => setShow(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;

    if (tnkbSubDaerah === null) {
      setTnkbSubDaerah('   ');
    } else {
      setTnkbSubDaerah(event.target.elements.tnkbSubDaerah.value);
    }

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setIsLoading(true);
      const submitFormData = {
        nomor_polisi: formatSubmitNopol(
          event.target.elements.tnkbDaerah.value,
          event.target.elements.tnkbSubDaerah.value,
          event.target.elements.tnkbNomor.value
        ),
        nik: event.target.elements.no_ktp.value,
        nomor_rangka: event.target.elements.no_rangka.value,
        nomor_hp: event.target.elements.no_hp.value,
        email: event.target.elements.email.value,
      };

      prosesPenghapusan(submitFormData).then((response) => {
        if (response?.data?.code === '0000') {
          navigate('/success', {
            state: {
              submitFormData,
            },
          });
        } else {
          setShow(true);
        }
        setIsLoading(false);
      });
    }

    event.preventDefault();
    setValidated(true);
  };

  return (
    <>
      <div className="custom-card p-3">
        <div className="card-body">
          <h5 className="card-title mb-3">Silakan Lengkapi data berikut:</h5>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formTnkbDaerah">
              <Form.Label>Nomor Polisi</Form.Label>
              <Row className="gx-1">
                <Col xs={3}>
                  <Form.Select
                    aria-label="pilih wilayah"
                    name="tnkbDaerah"
                    onChange={(e) => setTnkbDaerah(e.target.value)}
                    value={tnkbDaerah}
                    required
                  >
                    <option value={"D"}>D</option>
                    <option value={"E"}>E</option>
                    <option value={"F"}>F</option>
                    <option value={"T"}>T</option>
                    <option value={"Z"}>Z</option>
                  </Form.Select>
                </Col>
                <Col>
                  <Form.Control
                    name="tnkbNomor"
                    placeholder="1234"
                    maxLength={4}
                    onChange={(e) => setTnkbNomor(e.target.value)}
                    value={tnkbNomor}
                    required
                  ></Form.Control>
                </Col>
                <Col>
                  <Form.Control
                    placeholder="ABC"
                    maxLength={3}
                    name="tnkbSubDaerah"
                    onChange={(e) =>
                      setTnkbSubDaerah(e.target.value.toUpperCase())
                    }
                    value={tnkbSubDaerah}
                  ></Form.Control>
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formNoKTP">
              <Form.Label>Nomor KTP/NPWP Perusahaan</Form.Label>
              <Form.Control
                name="no_ktp"
                placeholder="Masukkan nomor KTP/NPWP Perusahaan Anda Disini"
                maxLength={16}
                onChange={(e) => setNoKTP(e.target.value)}
                value={noKTP}
                required
              ></Form.Control>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formNoRangka">
              <Form.Label className="mb-0">Nomor Rangka Kendaraan</Form.Label>
              <br />
              <Form.Text className="text-muted">6 Karakter terakhir</Form.Text>
              <Form.Control
                className="mt-2"
                placeholder="Masukkan nomor Rangka Kendaraan Anda Disini"
                maxLength={6}
                name="no_rangka"
                onChange={(e) => setNoRangka(e.target.value.toUpperCase())}
                value={noRangka}
                required
              ></Form.Control>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formNoRangka">
              <Form.Label className="mb-0">Nomor Handphone</Form.Label>
              <br />
              <Form.Text className="text-muted">
                Pastikan nomor handphone yang dimasukkan merupakan nomor aktif
              </Form.Text>
              <Form.Control
                name="no_hp"
                className="mt-2"
                placeholder="Masukkan nomor Handphone Anda Disini"
                maxLength={13}
                onChange={(e) => setNoHP(e.target.value)}
                value={noHP}
                required
              ></Form.Control>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formNoRangka">
              <Form.Label className="mb-0">Email</Form.Label>
              <br />
              <Form.Text className="text-muted">
                Pastikan Email yang dimasukkan merupakan email yang terdaftar
              </Form.Text>
              <Form.Control
                name="email"
                className="mt-2"
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder="Masukkan Email Anda Disini"
                required
              ></Form.Control>
            </Form.Group>

            <button
              className="btn primary-button"
              type="submit"
              disabled={isLoading}
            >
              <span className="px-2">
                {isLoading ? 'Memproses.. ' : 'Submit'}
              </span>

              {/* Loader  */}
              {isLoading && (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="loader"
                >
                  <path
                    d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM3.5 10C3.5 13.5899 6.41015 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5C6.41015 3.5 3.5 6.41015 3.5 10Z"
                    fill="#BDBDBD"
                  />
                  <path
                    d="M10 0C11.3132 1.566e-08 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10L16.5 10C16.5 9.14641 16.3319 8.30117 16.0052 7.51256C15.6786 6.72394 15.1998 6.00739 14.5962 5.40381C13.9926 4.80023 13.2761 4.32144 12.4874 3.99478C11.6988 3.66813 10.8536 3.5 10 3.5L10 0Z"
                    fill="white"
                  />
                </svg>
              )}

              {/* Logo Send */}
              {!isLoading && (
                <svg
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.8188 0.681243C14.7344 0.597289 14.6278 0.539162 14.5116 0.513697C14.3953 0.488232 14.2742 0.496488 14.1625 0.537493L0.412501 5.53749C0.293918 5.58247 0.191825 5.66246 0.119782 5.76684C0.0477393 5.87122 0.00915527 5.99504 0.00915527 6.12187C0.00915527 6.24869 0.0477393 6.37252 0.119782 6.4769C0.191825 6.58127 0.293918 6.66126 0.412501 6.70624L6.4125 9.10624L8.8125 15.1062C8.85759 15.2196 8.93488 15.3173 9.03484 15.3873C9.13479 15.4572 9.25304 15.4964 9.375 15.5C9.5013 15.4974 9.62386 15.4566 9.72651 15.383C9.82915 15.3093 9.90708 15.2063 9.95 15.0875L14.95 1.33749C14.9926 1.22692 15.0029 1.10651 14.9796 0.990321C14.9564 0.874129 14.9006 0.766937 14.8188 0.681243ZM9.375 13.125L7.63125 8.74999L10.625 5.75624L9.74375 4.87499L6.725 7.89374L2.375 6.12499L13.3313 2.16874L9.375 13.125Z"
                    fill="white"
                  />
                </svg>
              )}
            </button>
          </Form>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <div className="col-md-12 d-flex align-items-center justify-content-center">
            <img
              className="warning-image m-2 p-0 my-4"
              src={iconNegative}
              alt="Langkah-langkah Penggunaan Sistem"
            />
          </div>
          <p className="caption text-center">
            Mohon maaf data kendaraan dengan kombinasi berikut tidak ditemukan
          </p>
          <Form>
            <fieldset disabled>
              <Form.Group className="mb-3" controlId="formTnkbDaerah">
                <Form.Label>Nomor Polisi</Form.Label>
                <Row className="gx-1">
                  <Col xs={3}>
                    <Form.Select
                      aria-label="pilih wilayah"
                      name="tnkbDaerah"
                      defaultValue={tnkbDaerah}
                      required
                    >
                      <option value={'D'}>D</option>
                      <option value={'E'}>E</option>
                      <option value={'F'}>F</option>
                      <option value={'Z'}>Z</option>
                    </Form.Select>
                  </Col>
                  <Col>
                    <Form.Control
                      name="tnkbNomor"
                      placeholder="1234"
                      maxLength={4}
                      defaultValue={tnkbNomor}
                      required
                    ></Form.Control>
                  </Col>
                  <Col>
                    <Form.Control
                      // placeholder="ABC"
                      maxLength={3}
                      name="tnkbSubDaerah"
                      defaultValue={tnkbSubDaerah}
                    ></Form.Control>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formNoKTP">
                <Form.Label>Nomor KTP</Form.Label>
                <Form.Control
                  name="no_ktp"
                  placeholder="Masukkan nomor KTP Anda Disini"
                  maxLength={16}
                  defaultValue={noKTP}
                  required
                ></Form.Control>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formNoRangka">
                <Form.Label className="mb-0">Nomor Rangka</Form.Label>
                <br />
                <Form.Text className="text-muted">
                  6 Karakter terakhir
                </Form.Text>
                <Form.Control
                  className="mt-2"
                  placeholder="Masukkan nomor Rangka Anda Disini"
                  maxLength={6}
                  name="no_rangka"
                  defaultValue={noRangka}
                  required
                ></Form.Control>
              </Form.Group>
            </fieldset>

            <button
              className="btn primary-button"
              type="button"
              onClick={handleClose}
            >
              <span className="px-2">Periksa Kembali</span>
            </button>
          </Form>
          <p className="caption mt-4">
            Jika terdapat kendala, silakan hubungi nomor berikut :{' '}
          </p>
          <p className="caption mb-1">
            Whatsapp :{" "}
            <a className="base-heading-green" href="http://wa.me/6281122301818">
              081122301818
            </a>
          </p>
          <p className="caption">
            Call Center : <b>150 410</b>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}
